var Backbone = require('backbone');

export default Backbone.Collection.extend({
  url: '/joinos/api/offers/icons',
  parse: response => response.results
});



// WEBPACK FOOTER //
// ./offers/collections/icons.js